module.exports = __webpack_public_path__ + "static/media/security.5748a07a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/security.svg
// module id = 867
// module chunks = 21